import AuthService from 'services/auth.service';
import namespaceService from 'services/namespace.service';
import jwtService from '@services/jwt.service';
import PermissionService from '@services/permission.service';
import { orgIDEnum } from 'common/constants/appNames';
const initializeDatadogRum = ({ clientToken, applicationId, site }) => {
    if (!window.DD_RUM) {
        console.error('Datadog RUM not found on window object');
        return;
    }
    window.DD_RUM.init({
        clientToken: clientToken,
        applicationId: applicationId,
        site: site,
        env: localStorage.getItem('environment') ?? 'development',
        sessionSampleRate: 100,
        sessionReplaySampleRate: 100,
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        defaultPrivacyLevel: 'allow',
        //todo: we need each individual app to pass set the version for this to accurately show the image tags, right now only OUI is doing it correctly
        version: VERSION,
    });
    const getOrgType = (canViewAssetDataStore, orgTypeId) => {
        if (orgTypeId === orgIDEnum.CODERED) {
            return canViewAssetDataStore() ? 'CODERED ADS' : 'CODERED NonADS';
        }
        if (orgTypeId === orgIDEnum.OP) {
            return canViewAssetDataStore() ? 'OP ADS' : 'OP NON ADS';
        }
        return 'Invalid Org Config';
    };
    const setUserDetailsInDatadog = () => {
        const { canViewAssetDataStore } = new PermissionService().permissions;
        const userAssetId = canViewAssetDataStore() ? jwtService.getUserAssetId() : jwtService.getUserUuid();
        const orgUuid = jwtService.getOrganizationUuid();
        const orgTypeId = jwtService.getOrgTypeId();
        const orgType = getOrgType(canViewAssetDataStore, orgTypeId);
        window.DD_RUM.setUser({
            id: userAssetId,
        });
        window.DD_RUM.setUserProperty('OrgId', orgUuid);
        window.DD_RUM.setUserProperty('UserId', userAssetId);
        window.DD_RUM.setUserProperty('UserOrgName', namespaceService.getNamespace());
        window.DD_RUM.setUserProperty('OrgType', orgType);
        window.DD_RUM.setUserProperty('Environment', namespaceService.getOriginWithoutNamespace());
    };
    if (AuthService?.isAuthenticated) {
        setUserDetailsInDatadog();
    }
};
export const startDatadogRUM = (datadogConfig) => {
    //determined by "allowObservability" FF in Tahoe EM, enabled for all orgs by default
    const { clientToken = '', applicationId = '', site = '' } = datadogConfig;
    const canUseDatadogRUM = new PermissionService().permissions.canUseDatadogRUM;
    const dataDogEnabled = canUseDatadogRUM();
    if (!clientToken || !applicationId || !site || !dataDogEnabled) {
        return;
    }
    const scriptId = 'datadog-rum-script';
    if (!document.getElementById(scriptId)) {
        const script = document.createElement('script');
        script.id = scriptId;
        script.src = 'https://www.datadoghq-browser-agent.com/datadog-rum-v6.js';
        script.onload = () => initializeDatadogRum({ clientToken, applicationId, site });
        script.onerror = () => {
            console.error('Error loading Datadog RUM script');
        };
        document.head.appendChild(script);
    }
    else {
        initializeDatadogRum(datadogConfig);
    }
};
